// @flow
import * as Payload from 'modules/Authenticate/types/payload'
import config from 'config'
import {actionTypes} from './constants'
import type {AuthenticateState} from './types/index'
import type {Handlers, Action} from 'modules/Common/types'

export const initialState: AuthenticateState = {
  matrixAccessToken: null,
  matrixId: null,
  accessToken: null,
  userId: null,
  companyId: null,
  isLogging: false,
  error: null,
  isLoadingUserDetail: false,
  userDetail: null,
  ticket: null,
  phoneNumber: null,
  isResendingOTP: false,
  version: config.VERSION,
  buildNumber: config.BUILD_NUMBER,
  isAdmin: false
}

const handlers: Handlers<AuthenticateState> = {
  [actionTypes.FETCH_TOKEN_FROM_STORAGE]: (state, action: Action<any>) => {
    return {
      ...state,
      accessToken: action.payload.accessToken,
      matrixAccessToken: action.payload.matrixAccessToken,
      matrixId: action.payload.matrixId,
      userId: action.payload.userId,
      companyId: action.payload.companyId,
      isAdmin: action.payload.isAdmin
    }
  },
  [actionTypes.LOGOUT]: (state, action: Action<any>) => {
    return {
      ...state,
      accessToken: null,
      matrixAccessToken: null,
      matrixId: null,
      userId: null,
      companyId: null,
      ticket: null,
      phoneNumber: null
    }
  },
  [actionTypes.LOGIN_REQUEST]: (
    state,
    action: Action<Payload.LoginRequest>
  ) => {
    return {
      ...state,
      isLogging: true,
      error: null
    }
  },
  [actionTypes.LOGIN_SUCCESS]: (
    state,
    action: Action<Payload.LoginSuccess>
  ) => {
    return {
      ...state,
      isLogging: false,
      error: null,
      phoneNumber: action.payload.phoneNumber,
      ticket: action.payload.ticket,
      userId: action.payload.userId,
      companyId: action.payload.companyId
    }
  },
  [actionTypes.LOGIN_FAILURE]: (
    state,
    action: Action<Payload.LoginFailure>
  ) => {
    return {
      ...state,
      isLogging: false,
      error: action.payload.error
    }
  },

  [actionTypes.LOGIN_MATRIX_SUCCESS]: (
    state,
    action: Action<Payload.LoginMatrixSuccess>
  ) => {
    return {
      ...state,
      matrixAccessToken: action.payload.matrixAccessToken,
      matrixId: action.payload.matrixId
    }
  },

  [actionTypes.VERIFY_LOGIN_REQUEST]: (
    state,
    action: Action<Payload.VerifyLoginRequest>
  ) => {
    return {
      ...state,
      isLogging: true,
      error: null
    }
  },
  [actionTypes.VERIFY_LOGIN_SUCCESS]: (
    state,
    action: Action<Payload.VerifyLoginSuccess>
  ) => {
    return {
      ...state,
      isLogging: false,
      error: null,
      matrixAccessToken: action.payload.matrixAccessToken,
      matrixId: action.payload.matrixId,
      accessToken: action.payload.accessToken,
      userId: action.payload.userId,
      companyId: action.payload.companyId,
      isAdmin: action.payload.isAdmin
    }
  },
  [actionTypes.VERIFY_LOGIN_FAILURE]: (
    state,
    action: Action<Payload.VerifyLoginFailure>
  ) => {
    return {
      ...state,
      isLogging: false,
      error: action.payload.error
    }
  }
}

export default function reducer(
  state: AuthenticateState = initialState,
  action: Action<*>
) {
  if (!action || !action.type) {
    return state
  }

  const handler = handlers[action.type]

  if (handler == null) {
    return state
  }

  return handler(state, action)
}
